import React from "react";
import { Link } from "react-router-dom";

const UserLink = ({
  user,
  currentUserId,
  className,
  secondaryClassName,
  disableLink,
  emptyLabel = "-",
  target,
  rel,
}) => {
  if (!user?.id) return emptyLabel;

  const isCurrentUser = user.id === currentUserId;
  const shouldDisableLink = disableLink || isCurrentUser;

  const content = (
    <>
      {user.name} <span className={secondaryClassName}>{`(${user.id})`}</span>
    </>
  );

  if (shouldDisableLink) {
    return <span>{content}</span>;
  }

  return (
    <Link
      to={`/user-detail/${user.id}`}
      className={className}
      target={target}
      rel={rel}
    >
      {content}
    </Link>
  );
};

export default UserLink;